import React from 'react';

const TotalsBar = ({ totals }) => (
  <div className="totals-bar">
    <div className="totals-left">
      <span>Total Products: {totals.totalProducts}</span>
      <span>Total Quantity: {totals.totalQuantity}</span>
    </div>
    <div className="totals-right">
      <div>Subtotal: ₹{totals.subtotal}</div>
      <div>(-) Discount: ₹{totals.discount}</div>
      <div>Taxable: ₹{totals.taxableAmount}</div>
      <div>(+) GST: ₹{totals.gstAmount}</div>
      <div>(+) Delivery: ₹{totals.customChargeAmount}</div>
      <span className="total-amount">Total: ₹{totals.totalAmount}</span>
    </div>
  </div>
);

export default TotalsBar;
